<template>
  <div class="fill-height">
    <v-tabs-items class="overflow-auto fill-height" v-model="step">
      <v-tab-item class="fill-height" v-for="(accountStep, i) of accountOpenSteps" :key="i">
        <component :is="accountStep.component" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { formatPhone } from "@/mixins/formatPhone";
import MeetingDetailsOpenAccountForm from "./MeetingDetailsOpenAccountForm";
import MeetingDetailsOpenAccountPassport from "./MeetingDetailsOpenAccountPassport";
import MeetingDetailsOpenAccountPlans from "./MeetingDetailsOpenAccountPlans";
import MeetingDetailsOpenAccountProducts from "./MeetingDetailsOpenAccountProducts";
import MeetingDetailsOpenAccountUpload from "./MeetingDetailsOpenAccountUpload";
import MeetingDetailsFillFields from "./MeetingDetailsFillFields";
import MeetingDetailsMobileId from "./MeetingDetailsMobileId";

export default {
  mixins: [formatPhone],

  components: {
    MeetingDetailsOpenAccountForm,
    MeetingDetailsOpenAccountPassport,
    MeetingDetailsOpenAccountPlans,
    MeetingDetailsOpenAccountProducts,
    MeetingDetailsOpenAccountUpload,
    MeetingDetailsFillFields,
    MeetingDetailsMobileId
  },

  computed: {
    ...mapState("meeting", ["accountOpenStep"]),
    ...mapGetters("meeting", ["accountOpenSteps"]),
    step: {
      get() {
        return this.accountOpenStep;
      },
      set(v) {
        this.setAccountOpenStep(v);
      }
    }
  },

  methods: {
    ...mapMutations("meeting", ["setAccountOpenStep"])
  }
};
</script>
